import React from 'react';
import { string, number } from 'prop-types';
import styled from 'styled-components';

import { format } from '@olxbr/mojo-jojo/utils/string';

const Message = styled.div`
  margin: 2px 24px;
  font-size: 14px;
  line-height: 19.6px;
`;

const FreeRenewalMessage = ({ message, availableLimit }) => {
  return message ? <Message>{format(message, { insertionPlanAvailableLimit: availableLimit - 1 })}</Message> : null;
};

FreeRenewalMessage.propTypes = {
  message: string,
  availableLimit: number,
};

FreeRenewalMessage.defaultProps = {
  message: '',
  availableLimit: 0,
};

export default FreeRenewalMessage;
